import { render } from "./alert.vue?vue&type=template&id=08882c1c"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import "./alert.vue?vue&type=style&index=0&id=08882c1c&lang=scss"

import exportComponent from "/home/ubuntu/odk/odk-ssdd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__